import React, { useEffect, useState } from "react";
import DropDownList from "saur_ui_library/src/Molecules/DropDownList/DropDownList";
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import Card from 'saur_ui_library/src/Molecules/Card/Card';

import { createGlobalStyle } from "styled-components";
import { DataStatisticApi } from "../../../utils/api";
import { dateFr, maximumDate } from "../../../utils/helper";
import { inputTextDate, reformatDate } from "../../../utils/helpers/view/detailsHelper";
import ModernDatePicker from "../../common/component/ModernDatePicker";

const FilterFormMonitoring = (props:any) => {
  const [ojectsList, setObjectsList] = useState([]);
  const [objectParam, setObjectParam] = useState('');
  const [regionsList, setRegionList] = useState([]);
  const [regionParam, setRegionParam] = useState('');
  const [typeList, setTypeList] = useState([]);
  const [typeParam, setTypeParam] = useState('');
  const [classMeasureList, setClassMeasureList] = useState([]);
  const [classParam, setClassParam] = useState('');
  const [startDate, setStartDate] = useState<any>();
  const [endDate, setEndDate] = useState<any>();

  const getObject = async () => {
    const objectresponse = await DataStatisticApi.getObjectList();
    setObjectsList(objectresponse.data);
  };
  const getRegion = async () => {
    const regionresponse = await DataStatisticApi.getRegionsList();
    setRegionList(regionresponse.data);
  };
  const getType = async () => {
    const typeresponse = await DataStatisticApi.getTypesList();
    setTypeList(typeresponse.data);
  };
  const getClassMeasure = async () => {
    const measureresponse = await DataStatisticApi.getclassMeasureCodesList();
    setClassMeasureList(measureresponse.data);
  };

  useEffect(() => {
    getClassMeasure();
    getObject();
    getRegion();
    getType();
  }, []);

  useEffect(() => {
    props.monitoringCallback(
      reformatDate(startDate),
      reformatDate(endDate),
      objectParam,
      regionParam,
      typeParam,
      classParam
    );
  }, [startDate, endDate, objectParam, regionParam, typeParam, classParam]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Container className='filterFormMonitoring'>
      <Styles />
      <Card automatedTestId='monitoring-filter'>
        <Word
          value='FILTRER MA RECHERCHE'
          textStyle='title'
          variant='h1'
          automatedTestId='monitoring-search-word'
        />
        <Container className='formdrop'>
          <Container className='formLineDateItem'>
            <ModernDatePicker
              className='startDatePick'
              value={startDate}
              inputPlaceholder='Selectionner une date'
              maximumDate={maximumDate()}
              shouldHighlightWeekends
              formatInputText={() => {
                return inputTextDate(startDate);
              }}
              locale={dateFr}
              onChange={(d: any) => {
                setStartDate(d);
              }}
            />
          </Container>
          <Container className='formLineDateItem'>
            <ModernDatePicker
              className='endDatePick'
              value={endDate}
              inputPlaceholder='Selectionner une date '
              minimumDate={startDate}
              maximumDate={maximumDate()}
              shouldHighlightWeekends
              formatInputText={() => {
                return inputTextDate(endDate);
              }}
              locale={dateFr}
              onChange={(d: any) => {
                setEndDate(d);
              }}
            />
          </Container>
          <Container className='formLineDateItem'>
          <DropDownList
            className='object-dropdown'
            placeHolder='Selectionnez un objet'
            onChange={(v: any) => {
              setObjectParam(v.value);
            }}
            values={ojectsList.map((obj: any, i) => {
              return {
                id: i,
                value: obj,
                label: obj,
              };
            })}
          />
          </Container>
        </Container>
        <Container className='formdrop'>
        <Container className='formLineDateItem'>
          <DropDownList
            className='region-dropdown'
            placeHolder='Selectionnez une région'
            onChange={(v) => {
              setRegionParam(v.value);
            }}
            values={regionsList.map((reg: any, i) => {
              return {
                id: i,
                value: reg,
                label: reg,
              };
            })}
          />
          </Container>
          <Container className='formLineDateItem'>
          <DropDownList
            className='type-dropdown'
            placeHolder='Selectionnez un type'
            onChange={(v) => {
              setTypeParam(v.value);
            }}
            values={typeList.map((t: any, i) => {
              return {
                id: i,
                value: t,
                label: t,
              };
            })}
          />
          </Container>
          <Container className='formLineDateItem'>
          <DropDownList
            className='classmeasure-dropdown'
            placeHolder='Selectionnez une class measure code'
            onChange={(v) => {
              setClassParam(v.value);
            }}
            values={classMeasureList.map((c: any, i) => {
              return {
                id: i,
                value: c,
                label: c,
              };
            })}
          />
          </Container>
        </Container>
      </Card>
    </Container>
  );
};

const Styles = createGlobalStyle`
.sds-reset-style{
  .filterFormMonitoring{
    .sds-container.sds-m-card {
    overflow: visible !important;
    margin-bottom: 25px;
    .formdrop{
      flex-direction:row;
      justify-content: space-between;
      margin-top: 10px;
      margin-bottom: 10px;

      .object-dropdown,.region-dropdown,
      .type-dropdown, .classmeasure-dropdown {
        position: relative;
        background-color:#edf2fa;
      }
    }
    }
    .dateContainer{
   flex-direction:row;
   height: fit-content;
 }
 input.DatePicker__input.-ltr.my-custom-input{
   background: none;
   border: none;
   line-height:3;
   padding: 0;
   min-width: 210px;
 }
 .formLineDateItem {
    /* align-items: center; */
    position: relative;
    background-color:#edf2fa;
    width: 32%;
  }
  }
  .sds-m-modern-date-picker{
    margin-bottom: 0px !important;
  }
  .DatePicker__calendarContainer{
    margin-left: 100px
  }
}`;

export default FilterFormMonitoring;
